// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__+-+13","card":"Panel_card__jXl7A","card-body":"Panel_card-body__By-NJ"};